var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 49,
    viewBox: "0 0 67 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4144_12838)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 65,
    height: 47,
    rx: 23.5,
    fill: "url(#paint0_radial_4144_12838)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 48,
    rx: 24,
    stroke: "url(#paint1_linear_4144_12838)",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 26.2546V28.0103C44.9999 29.9415 43.2749 31.5216 41.1666 31.5216H25.2585L27.4627 33.5407C27.846 33.8918 27.846 34.4185 27.4627 34.7697C27.0793 35.1208 26.5043 35.1208 26.121 34.7697L22.2877 31.2583C21.9044 30.9072 21.9044 30.3805 22.2877 30.0293L26.121 26.518C26.5043 26.1668 27.0793 26.1668 27.4627 26.518C27.846 26.8691 27.846 27.3958 27.4627 27.7469L25.2585 29.766H41.1666C42.2208 29.766 43.0833 28.9759 43.0833 28.0103V26.2546C43.0833 25.7279 43.4666 25.3768 44.0416 25.3768C44.6166 25.3768 44.9999 25.7279 44.9999 26.2546ZM22.9586 23.6211C23.5336 23.6211 23.9169 23.2699 23.9169 22.7432V20.9876C23.9169 20.0219 24.7794 19.2319 25.8335 19.2319H41.7416L39.5375 21.2509C39.1542 21.6021 39.1542 22.1288 39.5375 22.4799C39.9208 22.831 40.4958 22.831 40.8791 22.4799L44.7124 18.9685C45.0957 18.6174 45.0957 18.0907 44.7124 17.7396L40.8791 14.2282C40.4958 13.8771 39.9208 13.8771 39.5375 14.2282C39.1542 14.5793 39.1542 15.106 39.5375 15.4572L41.7416 17.4762H25.8335C23.7252 17.4762 22.0002 19.0563 22.0002 20.9876V22.7432C22.0002 23.2699 22.3836 23.6211 22.9586 23.6211Z",
    fill: "#B4B5B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4144_12838",
    x: -42,
    y: -42,
    width: 151,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4144_12838"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4144_12838",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 1) rotate(35.8698) scale(80.2122 52.9279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32353D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32353D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4144_12838",
    x1: 1,
    y1: 1,
    x2: 8.36992,
    y2: 54.1894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32353D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotransaction);
export default __webpack_public_path__ + "static/media/No transaction.d8b35047686706c5c32392a3d34274ed.svg";
export { ForwardRef as ReactComponent };